/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// IMPORTANT: manter este import no topo. O módulo instancia o agente do
// New Relic como side-effect — fazê-lo antes de `@/plugins`, `./router` e
// demais imports garante que erros de bootstrap caiam no NR.
import { useNewRelic } from "@/composables/useNewRelic";

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";

// Composables
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createApp } from "vue";
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useBrandConfig } from "./composables/useBrand";
import { initializeFlowFromUrl } from "./config/flowConfig";
import router from "./router";
import "./styles/toast.css";
import {usePostHog} from "@/composables/usePostHog.ts";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
const { posthog } = usePostHog();
const { newrelic } = useNewRelic();

app.config.errorHandler = (err, instance, info) => {
  posthog.capture('$exception', {
    message: (err as Error).message,
    stack: (err as Error).stack,
    vue_info: info
  })

  newrelic?.noticeError(err as Error, { vue_info: info })
}

registerPlugins(app);

app.use(pinia);

app.use(Vue3Toastify, {
  autoClose: 3000,
  position: "top-center",
  closeButton: false,
  dangerouslyHTMLString: true,
  theme: "dark",
  toastClassName: "container-class",
  progressStyle: {
    background: "#F99E07",
  },
});
app.mount("#app");

const { page } = useBrandConfig();

page.initialize();

// desativado temporariamente para testes
// initializeFlowFromUrl(router);
